module.exports = __webpack_public_path__ + "img/flac.52f73af1.svg";